import { MultiValueGenericProps } from 'react-select';
import { SelectOption } from '../dropdown';
import { Chip } from '../../../chip';

export const DropdownMultiValueContainer = (props: MultiValueGenericProps<SelectOption>) => {
  const onDeleteChip = props.children?.[1]!.props.innerProps.onClick;

  return (
    <div
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onTouchEnd={(e) => {
        e.preventDefault();
        onDeleteChip();
      }}
      data-testid="dropdown-multi-value"
    >
      <Chip type="input" onDelete={onDeleteChip}>
        {props.data.label}
      </Chip>
    </div>
  );
};
